import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["list", "loading", "loadMoreButton"]
  static values = {
    voteId: String
  }

  declare readonly listTarget: HTMLElement
  declare readonly loadingTarget: HTMLElement
  declare readonly loadMoreButtonTarget: HTMLElement
  declare readonly voteIdValue: string
  private previousUrl: string | null = null
  private currentOffset: number = 0

  connect(): void {
    // Initialize offset from the current questions count
    const questions = this.listTarget.querySelectorAll('[data-question-id]')
    this.currentOffset = questions.length
  }

  showLoading(): void {
    this.loadingTarget.style.display = 'block'
  }

  hideLoading(): void {
    this.loadingTarget.style.display = 'none'
  }

  handleLoadMore(event: Event): void {
    this.previousUrl = window.location.href

    requestAnimationFrame(() => {
      window.history.pushState({}, '', this.previousUrl)
    })
  }
}
